module.exports = __webpack_public_path__ + "img/file-icon.b424c9b7.svg";